// import VTableInput from "./v-table-input.vue";

const components = {
  // VTableInput,
};

const install = function(Vue) {
  for (let item in components) {
    Vue.component(item, components[item]);
  }
};

export default {
  install
};
